import React, {useContext} from "react";
import {Location, Outlet, useNavigate, useOutletContext} from "react-router-dom";
import {Box, Button, Modal, styled, Theme} from "@mui/material";
import {BlurredBackdropModal} from "../components/BlurredBackdropModal/BlurredBackdropModal";
import CloseIcon from '@mui/icons-material/Close';
import {RouteContext} from "../routes/RouteContext";

export const EmptyLayout = () => {

    return (
        
           <Outlet/>
    );
}